import React from "react";
import "./App.css";

function App() {
  // Состояние для счётчика (просто чтобы кнопка что-то делала)
  const [count, setCount] = React.useState(0);

  return (
    <div className="container">
      <h1 className="title">L2 Tool</h1>
      <div className="buttons">
        <button className="button" onClick={() => setCount(count + 1)}>
          Click {count} раз
        </button>
        <button className="button">Second button</button>
      </div>
    </div>
  );
}

export default App;
